import React, { useState } from 'react';
import './About.css';

const About: React.FC = () => {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  const faqData = [
    {
      question: "Why do you not conduct an Ontario Safety Inspection in advance?",
      answers: [
        "Some customers prefer to purchase the vehicle without an inspection so that they can fix the cars and arrange for their own inspection in order to save costs.",
        "Some vehicles are sold to buyers located outside of the province or country, making an Ontario inspection redundant.",
        "An inspection certificate is only valid for 36 days from the Date of Inspection. After 36 days, the vehicle will need to be reinspected.",
        "Some vehicles are eventually sent to the auction and the inspection becomes redundant and the costs cannot be recouped."
      ]
    },
    {
      question: 'Why do all vehicles say "SOLD AS IS"?',
      answers: [
        'Any Vehicle that has not been subject to an Ontario Safety Inspection requires to be "SOLD AS IS" by OMVIC.'
      ]
    },
    {
      question: 'Why do all vehicles state "Not Roadworthy, not maintained, not good for transport etc". Does this mean that the vehicle is junk?',
      answers: [
        'Any vehicle that has not been subjected to an Ontario Safety Inspection requires to be "SOLD AS IS" by OMVIC and requires this disclaimer attached to the advertisement.'
      ]
    },
    {
      question: "Can you produce an invoice with a reduced sale price to save on duties and taxes?",
      answers: [
        "No. All receipts will be made for actual monies exchanged."
      ]
    },
    {
      question: "If we pay cash, can you produce an invoice with a reduced sale price to save on duties and taxes?",
      answers: [
        "No. We prefer certified checks or wire transfers as methods of payment. Cash is our least preferred option."
      ]
    }
  ];

  return (
    <div className="about">
      <section className="section">
        <div className="container">
          <div className="about-text">
            <h2>About</h2>
            <p>
              EuroJDM Auto is a specialty car dealership based in Ontario, Canada. We import vehicles
              from all over the world and provide our customers with hard to find, limited edition,
              collectible cars.
            </p>
            <p>
              We also ship most cars to the USA. We handle the shipping and customs process, provided
              that the vehicle is over 25 years old or an original Canadian car.
            </p>
            <p>
              Let us know what you're looking for and we can find it, ship it, import it and do the
              paperwork for registration.
            </p>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="section faq-section">
        <div className="container">
          <h2>FAQ</h2>
          <div className="faq-list">
            {faqData.map((faq, index) => (
              <div key={index} className={`faq-item ${openFAQ === index ? 'faq-open' : ''}`}>
                <button className="faq-trigger" onClick={() => setOpenFAQ(openFAQ === index ? null : index)}>
                  <span>{faq.question}</span>
                  <span className="faq-icon">{openFAQ === index ? '\u2212' : '+'}</span>
                </button>
                <div className="faq-answer">
                  <div className="faq-answer-inner">
                    {faq.answers.map((answer, ai) => (
                      <p key={ai}>{answer}</p>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
